export default "__VITE_ASSET__dfc65b77__"